import React from "react";
import { LoginBody } from "tsi-common-react/src/apps/customer-account/LoginBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <LoginBody {...props} />
    </PageSkeleton>
);
